import { useEffect, useState } from "react";
import { useWindowResize } from "./useWindowResize";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<{ width: number; height: number }>({
    width: 0,
    height: 0,
  });

  const handler = () => {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    setWindowSize({ width: windowWidth, height: windowHeight });
  };

  useWindowResize(handler);

  useEffect(() => {
    handler();

    return () => {
      setWindowSize({ width: 0, height: 0 });
    };
  }, []);

  return windowSize;
};
